import * as THREE from "three";

export type SoldierRig = {
  group: THREE.Group;
  leftLeg: THREE.Group;
  rightLeg: THREE.Group;
  leftArm: THREE.Group;
  rightArm: THREE.Group;
};

export function buildSoldier(mat: THREE.MeshStandardMaterial, tag: Record<string, boolean>): SoldierRig {
  const g = new THREE.Group();

  function mesh(geom: THREE.BufferGeometry): THREE.Mesh {
    const m = new THREE.Mesh(geom, mat);
    Object.assign(m.userData, tag);
    return m;
  }

  // Torso
  const torso = mesh(new THREE.BoxGeometry(0.55, 0.7, 0.28));
  torso.position.y = 0.95;
  g.add(torso);

  // Head + helmet
  const head = mesh(new THREE.SphereGeometry(0.18, 7, 6));
  head.position.y = 1.52;
  const helmet = mesh(new THREE.CylinderGeometry(0.19, 0.19, 0.14, 7));
  helmet.position.y = 1.63;
  g.add(head, helmet);

  // Arms — pivot from shoulder
  const makeArm = (side: number): THREE.Group => {
    const pivot = new THREE.Group();
    pivot.position.set(side * 0.34, 1.25, 0);
    const upper = mesh(new THREE.CylinderGeometry(0.07, 0.07, 0.38, 5));
    upper.position.y = -0.19;
    pivot.add(upper);
    g.add(pivot);
    return pivot;
  };
  const leftArm = makeArm(-1);
  const rightArm = makeArm(1);

  // Legs — pivot from hip
  const makeLeg = (side: number): THREE.Group => {
    const pivot = new THREE.Group();
    pivot.position.set(side * 0.16, 0.6, 0);
    const upper = mesh(new THREE.CylinderGeometry(0.09, 0.08, 0.42, 5));
    upper.position.y = -0.21;
    const lower = mesh(new THREE.CylinderGeometry(0.07, 0.06, 0.38, 5));
    lower.position.y = -0.52;
    pivot.add(upper, lower);
    g.add(pivot);
    return pivot;
  };
  const leftLeg = makeLeg(-1);
  const rightLeg = makeLeg(1);

  return { group: g, leftLeg, rightLeg, leftArm, rightArm };
}

// Called each frame; phase advances externally. moving=false = idle stand.
export function animateSoldier(rig: SoldierRig, phase: number, moving: boolean): void {
  const swing = moving ? Math.sin(phase * 4) * 0.4 : Math.sin(phase * 0.8) * 0.04;
  rig.leftLeg.rotation.x  =  swing;
  rig.rightLeg.rotation.x = -swing;
  rig.leftArm.rotation.x  = -swing * 0.5;
  rig.rightArm.rotation.x =  swing * 0.5;
}
